import React__default from 'react';
import { DataViewElementsAuthorizedIcon } from '@keepeek/commons';
import clsx from 'clsx';

var ICONS_OVER_MEDIA_LIST = [
    {
        authorizedIcon: DataViewElementsAuthorizedIcon.VIDEO,
        mimeTypePattern: /^video\//,
        iconKey: "fa-regular fa-circle-play fa-2xl",
        className: "IconOverMedia-video"
    },
    {
        authorizedIcon: DataViewElementsAuthorizedIcon.IMAGE,
        mimeTypePattern: /image\//,
        iconKey: "fa-solid fa-image fa-2xl",
        className: "IconOverMedia-image"
    },
    {
        authorizedIcon: DataViewElementsAuthorizedIcon.PDF,
        mimeTypePattern: /pdf/,
        iconKey: "fa-solid fa-file-pdf fa-2xl",
        className: "IconOverMedia-pdf"
    },
    {
        authorizedIcon: DataViewElementsAuthorizedIcon.AUDIO,
        mimeTypePattern: /audio/,
        iconKey: "fa-solid fa-volume fa-2xl",
        className: "IconOverMedia-audio"
    },
];
var findIconOverMedia = function (authorizedIcons, element) {
    if (!authorizedIcons || !element) {
        return;
    }
    return ICONS_OVER_MEDIA_LIST.find(function (icon) {
        return (authorizedIcons === null || authorizedIcons === void 0 ? void 0 : authorizedIcons.includes(icon.authorizedIcon)) &&
            (element === null || element === void 0 ? void 0 : element.mediaType.match(icon.mimeTypePattern));
    });
};
var IconOverMedia = function (_a) {
    var element = _a.element, authorizedIcons = _a.authorizedIcons, KIcon = _a.KIcon, _b = _a.testId, testId = _b === void 0 ? "IconOverMedia" : _b, id = _a.id, className = _a.className;
    var icon = findIconOverMedia(authorizedIcons, element);
    if (icon && KIcon) {
        return (React__default.createElement(KIcon, { sx: {
                color: function (theme) { return theme.palette.background.paper; },
                textShadow: "0 2px 3px rgba(0,0,0,0.5)"
            }, fontSize: "large", "data-testid": testId, id: id, className: clsx("IconOverMedia", icon.className, className, icon.iconKey) }));
    }
    return null;
};

export { IconOverMedia as default };
//# sourceMappingURL=index.js.map
